
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics",
      function () {
        return require("private-next-pages/topics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics"])
      });
    }
  